import { Spinner, CenterBlock } from '@amperio/amperio-ui';

export const FullScreenLoading = (): JSX.Element => (
  <CenterBlock>
    <Spinner size="large" />
  </CenterBlock>
);
